module.exports = __webpack_public_path__ + "platform/static/media/contact.35a46526.svg";